import { useState } from 'react';

const UserModel = () => {
  const [userInfo, setUserInfo] = useState({});

  const state = {
    userInfo,
  };
  const actions = {
    setUserInfo,
  };

  return {
    ...state,
    ...actions,
  };
};

export default UserModel;
